import CryptoJS from "crypto-js";
const TOKEN_KEY = "token";
const USER_NAME = "userName";
const PERMISSIONS_MENU_IDS_KEY = "permissionsMenuIds";
const PERMISSIONS_MENUS_DETAIL_KEY = "permissionsMenusDetail";
const USER_INFO_KEY = "userInfoList";
const CURRENT_USER_KEY = "currentUser";
const CURRENCY_USER_KEY = "CurrencyCode";
/**
 * 存储用户信息列表
 */
export function setUserInfoList(userInfoList) {
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfoList));
}

/**
 * 获取用户信息列表
 */
export function getUserInfoList() {
  const data = localStorage.getItem(USER_INFO_KEY);
  return data ? JSON.parse(data) : null;
}

/**
 * 存储当前用户
 */
export function setCurrentUser(user) {
  localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(user));
}

/**
 * 获取当前用户
 */
export function getCurrentUser() {
  const data = localStorage.getItem(CURRENT_USER_KEY);
  return data ? JSON.parse(data) : null;
}

/**
 * 清除用户数据
 */
export function clearUserData() {
  localStorage.removeItem(USER_INFO_KEY);
  localStorage.removeItem(CURRENT_USER_KEY);
}
/**
 * 获取 Token
 * @returns {string|null} 返回存储的 token 或 null
 */
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export async function getF() {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  ctx.textBaseline = "top";
  ctx.font = "14px Arial";
  ctx.fillStyle = "#f60";
  ctx.fillText("CanvasFingerprint", 2, 15);
  ctx.strokeStyle = "rgba(102, 204, 0, 0.7)";
  ctx.beginPath();
  ctx.moveTo(10, 10);
  ctx.lineTo(50, 50);
  ctx.stroke();
  const gradient = ctx.createLinearGradient(0, 0, 50, 50);
  gradient.addColorStop(0, "#ff0000");
  gradient.addColorStop(1, "#0000ff");
  ctx.fillStyle = gradient;
  ctx.fillRect(60, 60, 50, 50);
  const imageData = ctx.getImageData(0, 0, 100, 100);
  ctx.putImageData(imageData, 0, 0);
  const dataURL = canvas.toDataURL();
  let uuid = localStorage.getItem("canvas_fingerprint_uuid");
  if (!uuid) {
    uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
    localStorage.setItem("canvas_fingerprint_uuid", uuid);
  }
  return CryptoJS.MD5(dataURL + uuid).toString();
}

/**
 * 设置 Token
 * @param {string} token - 要存储的 token
 */
export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

/**
 * 清除 Token
 */
export function removeToken() {
  localStorage.removeItem(TOKEN_KEY);
}

/**
 * 获取 permissionsMenuIds
 * @returns {Array|null} 返回存储的 permissionsMenuIds 或 null
 */
export function getPermissionsMenuIds() {
  const data = localStorage.getItem(PERMISSIONS_MENU_IDS_KEY);
  return data ? JSON.parse(data) : null;
}

/**
 * 设置 permissionsMenuIds
 * @param {Array} menuIds - 要存储的 permissionsMenuIds
 */
export function setPermissionsMenuIds(menuIds) {
  localStorage.setItem(PERMISSIONS_MENU_IDS_KEY, JSON.stringify(menuIds));
}

/**
 * 获取 permissionsMenusDetail
 * @returns {Array|null} 返回存储的 permissionsMenusDetail 或 null
 */
export function getPermissionsMenusDetail() {
  const data = localStorage.getItem(PERMISSIONS_MENUS_DETAIL_KEY);
  return data ? JSON.parse(data) : null;
}

/**
 * 设置 permissionsMenusDetail
 * @param {Array} menusDetail - 要存储的 permissionsMenusDetail
 */
export function setPermissionsMenusDetail(menusDetail) {
  localStorage.setItem(
    PERMISSIONS_MENUS_DETAIL_KEY,
    JSON.stringify(menusDetail)
  );
}

/**
 * 清除所有权限相关数据
 */
export function clearPermissionsData() {
  localStorage.removeItem(PERMISSIONS_MENU_IDS_KEY);
  localStorage.removeItem(PERMISSIONS_MENUS_DETAIL_KEY);
}

/**
 * 检查 Token 是否存在
 * @returns {boolean} true 表示 token 存在，否则为 false
 */
export function hasToken() {
  return !!getToken();
}

/**
 * 获取 userName
 * @returns {userName|null} 返回存储的 userName 或 null
 */
export function getUserName() {
  return localStorage.getItem(USER_NAME);
}

/**
 * 设置 userName
 * @param {userName} token - 要存储的 token
 */
export function setUserName(userName) {
  localStorage.setItem(USER_NAME, userName);
}

/**
 * 清除 userName
 */
export function removeUserName() {
  localStorage.removeItem(USER_NAME);
}

/**
 * 存储币种列表
 */
export function setCurrencyCode(data) {
  localStorage.setItem(CURRENCY_USER_KEY, JSON.stringify(data));
}

/**
 * 获取币种列表
 */
export function getCurrencyCode() {
  const data = localStorage.getItem(CURRENCY_USER_KEY);
  return data ? JSON.parse(data) : null;
}
